import { render, staticRenderFns } from "./FulfillmentOptionsFooterDelivery.vue?vue&type=template&id=6ed34428"
import script from "./FulfillmentOptionsFooterDelivery.vue?vue&type=script&lang=ts"
export * from "./FulfillmentOptionsFooterDelivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports